<template>
  <div>
    <b-modal size="xl" v-model="showRedemptionProcessingModal" :title="'Process Payout'" no-close-on-backdrop no-close-on-esc @hide="closeRedemptionProcessingModal">
      <div>
        <b-row>
          <b-col class="col-10">
            <b>Total Payable amount: </b>
          </b-col>
          <b-col class="col-2">
            <input v-model="redemeedAmt" type="number" class="form-control"/>
          </b-col>
        </b-row>
        <span v-if="redemeedAmt < 0"><b>Alert:</b>&nbsp; We are running short of <span class="primary-color">{{redemeedAmt}}</span> and we need to collect it from the GIDEPreneur</span>
      </div>

      <!-- Proof of payment of commission -->
      <b-row class="mt-2">
        <div class="col-12 col-sm-12 col-md-6 col-12 mb-2">
          <label for="validationslot_acHolderName">Banking Transaction ID</label>&nbsp;<label class="primary-color font-size-16">*</label>
          <ValidationProvider name="Banking Transaction ID" rules="required|min:2" v-slot="{ errors }">
            <input v-model="vmPaymentProofFormData.payout_tid" type="text" class="form-control" required/>
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>

        <div class="col-12 col-sm-12 col-md-6 mb-2">
          <label for="validationslot_acHolderName">PayOut date</label>&nbsp;<label class="primary-color font-size-16">*</label>
          <ValidationProvider name="PayOut date" rules="required" v-slot="{ errors }">
            <input
                v-model="vmPaymentProofFormData.payout_date"
                type="date"
                class="form-control"
                required
              />
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>

        <div class="col-12 col-sm-12 col-md-6 mb-2">
          <UploadDocs :propDocsList="vmPaymentProofFormData.payout_tid_img" :propUploadInputLabel="`Upload Payment Screenshot`" :propAllowedExtensions="`application/pdf,image/png,image/jpg,image/jpeg,image/gif,image/webp`" @emitGetLatestDocs="emitGetLatestDocs" />
        </div>
      </b-row><!-- Proof of payment of commission -->

      <div class="col-12 mb-2">
        <label for="validationslot_acHolderName">Reason For Rejection(If any)</label>&nbsp;<label class="primary-color font-size-16">*</label>
        <ValidationProvider name="Reason for rejecting the redemption request" v-slot="{ errors }">
          <input v-model="vmPaymentProofFormData.reason_for_rejecting_redemption_req" type="text" class="form-control"/>
          <span class="text-danger">Put a valid reason for rejecting the redemption request, Note: this reason will be emailed to the GidePreneur</span>
        </ValidationProvider>
      </div>
      <p>
        <button type="button" class="btn btn-success ml-1 mt-1" @click="savePaymentProof()">Save Payment Proof</button>
        <button type="button" class="btn btn-primary ml-2 mt-1" @click="rejectRedemptionReq()">Reject Payout</button>
      </p>
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" variant="secondary" @click="closeRedemptionProcessingModal()">
          {{propCancelBtnText}}
        </b-button>
      </template>
    </b-modal>
    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg">
      </div>
    </b-toast>
  </div>
</template>

<script>
import "vue-datetime/dist/vue-datetime.css"
import { PayRedemption } from "../../../../FackApi/api/PayRedemption"
import ApiResponse from "../../../../Utils/apiResponse"
import { ValidationProvider } from "vee-validate"
import UploadDocs from "../../../../components/UploadDocs.vue"

export default {
  name: "ProcessRedemption",
  mounted () {
    this.redemptiondata = this.propRedemptionData
    this.showRedemptionProcessingModal = this.propShowRedemptionProcessingModal
    this.getRedemptionParticulars()
  },
  props: {
    propShowRedemptionProcessingModal: {
      type: Boolean,
      default: false
    },
    propRedemptionData: {
      type: Object,
      default: null
    },
    propOrgId: {
      type: String,
      default: null
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  data () {
    return {
      redemeedAmt: 0.00,
      redemptionParticulars: {},
      fileSrc: "",
      propCropDialogSize: "md",
      imageSize: "Size  1080 * 566",
      paymentProofImgLabel: "Payment Screenshot",
      propCropImageDialogOpen: false,
      propStencilSize: null,
      vmPaymentProofImg: null,
      vmPaymentProofFormData: {
        payout_tid_img: []
      },
      propCancelBtnText: "Cancel",
      redemptiondata: null,
      showRedemptionProcessingModal: false,
      creditStates: ["TOBEPAID", "TOBEAPPROVED"],
      debitStates: ["TOBERECOVERED"],
      processedStates: ["RECOVERED", "PAID"],
      toastTitle: "Process redemption",
      showToast: false,
      toastVariant: "default",
      toastMsg: ""
    }
  },
  components: {
    ValidationProvider,
    UploadDocs
  },
  methods: {
    /**
     * emitGetLatestDocs
     */
    emitGetLatestDocs (updatedDocsList) {
      this.vmPaymentProofFormData.payout_tid_img = updatedDocsList
    },
    /**
     * closeRedemptionProcessingModal
     */
    closeRedemptionProcessingModal (redemptionProcessStatus = false) {
      if (redemptionProcessStatus == true) {
        this.$emit("emitCloseRedemptionProcessingModal", redemptionProcessStatus)
      }
      else {
        this.$emit("emitCloseRedemptionProcessingModal")
      }
    },
    /**
     * getCroppedImg
     */
    getCroppedImg (img) {
      this.vmPaymentProofImg = img
    },
    /**
     * getRedemptionParticulars
     */
    async getRedemptionParticulars () {
      try {
        if (this.processedStates.includes(this.redemptiondata.redemption_status)) {
          // Opens the redemption processing modal for view/edit payment proof
          this.vmPaymentProofFormData = {
            pay_redeem_id: this.redemptiondata.pay_redeem_id,
            payout_tid: this.redemptiondata.payout_tid
          }
          this.vmPaymentProofImg = JSON.parse(this.redemptiondata.payout_tid_img)[0].url
          return
        }

        const payload = {
          org_id: this.propOrgId,
          org_admin_email: this.redemptiondata.org_admin_email,
          redemption_period: this.redemptiondata.redemption_period
        }

        let redemptionParticulars = await PayRedemption.payRedemptionGetParticulars(this, payload)
        if (!redemptionParticulars.resp_status) {
          ApiResponse.responseMessageDisplay(this, redemptionParticulars)
          return
        }
        this.redemeedAmt = this.userData.user_country == 99 ? redemptionParticulars.resp_data.final_amt_inr : redemptionParticulars.resp_data.final_amt_usd
        this.redemptionParticulars = redemptionParticulars.resp_data
      }
      catch (err) {
        console.error("Exception in getRedemptionParticulars() and err: ", err.message)
      }
    },
    /**
     * savePaymentProof
    */
    async savePaymentProof () {
      try {
        if (this.vmPaymentProofFormData.payout_tid_img && this.vmPaymentProofFormData.payout_tid_img.length == 0) {
          this.toastMsg = "Please upload a screenshot as a payment proof"
          this.toastVariant = "danger"
          this.showToast = true
          return
        }

        if (!this.vmPaymentProofFormData.payout_tid) {
          this.toastMsg = "Please provide the banking transaction id"
          this.toastVariant = "danger"
          this.showToast = true
          return
        }

        // append the pay_redeem_id and the org_id and user_country
        this.vmPaymentProofFormData.pay_redeem_id = this.redemptiondata.pay_redeem_id
        this.vmPaymentProofFormData.org_id = this.redemptiondata.org_id
        this.vmPaymentProofFormData.user_country = this.userData.user_country

        // append the commission and other details so that we can send details like redemption_period, commission_amt etc in the email to approved team
        this.vmPaymentProofFormData.commission_inr_with_gst = this.redemptiondata.commission_inr_with_gst
        this.vmPaymentProofFormData.commission_usd_with_gst = this.redemptiondata.commission_usd_with_gst

        this.vmPaymentProofFormData.commission_inr_without_gst = this.redemptiondata.commission_inr_without_gst
        this.vmPaymentProofFormData.commission_usd_without_gst = this.redemptiondata.commission_usd_without_gst

        this.vmPaymentProofFormData.redemption_period = this.redemptiondata.redemption_period
        this.vmPaymentProofFormData.payout_amount = this.redemeedAmt

        this.vmPaymentProofFormData.tobepaid_pay_redeem_id_list = JSON.stringify(this.redemptionParticulars.tobepaid_pay_redeem_id_list)
        this.vmPaymentProofFormData.tobededucted_pay_redeem_id_list = JSON.stringify(this.redemptionParticulars.tobededucted_pay_redeem_id_list)

        // append the asset type
        this.vmPaymentProofFormData.asset_key = "payout_tid_img"

        const paymentProofEditResp = await PayRedemption.payredeemEdit(this, this.vmPaymentProofFormData)
        if (!paymentProofEditResp.resp_status) {
          ApiResponse.responseMessageDisplay(this, paymentProofEditResp)
          return
        }
        this.closeRedemptionProcessingModal(true)
      }
      catch (err) {
        console.error("Exception in savePaymentProof() and err: ", err.message)
      }
    },
    /**
     * rejectRedemptionReq
     */
    async rejectRedemptionReq () {
      try {
        const payload = {
          pay_redeem_id: this.redemptiondata.pay_redeem_id,
          reason_for_rejection: this.vmPaymentProofFormData.reason_for_rejecting_redemption_req
        }
        const payRedemptionDeleteResp = await PayRedemption.payredeemRejectReq(this, payload)
        if (!payRedemptionDeleteResp.resp_status) {
          ApiResponse.responseMessageDisplay(this, payRedemptionDeleteResp)
          return
        }
        this.closeRedemptionProcessingModal(true)
      }
      catch (err) {
        console.error("Exception in rejectRedemptionReq() and err: ", err.message)
      }
    }
  }
}
</script>
<style lang="">
</style>
